module.exports = __webpack_public_path__ + "static/media/22.89ec06ae.jpg";